import { endOfDay, startOfDay } from "date-fns";
import PropTypes from "prop-types";
import { parseDate } from "../../../utils/date";
import DatePickerNative from "./DatePickerNative";

function toEvent(id, name, value) {
  const d = parseDate(value);
  const formatedValue = d ? d.toISOString() : "";
  return {
    target: {
      id: id || name,
      name: name || id,
      value: d || "",
      formatedValue,
    },
  };
}

export default function FromToDatePickerNative({ fra, til, onChange }) {
  const handleFraChange = (e) => {
    const picked = parseDate(e?.target?.value);
    const adjusted = picked ? startOfDay(picked) : "";
    onChange(toEvent(fra.id, fra.name, adjusted));
  };

  const handleTilChange = (e) => {
    const picked = parseDate(e?.target?.value);
    const adjusted = picked ? endOfDay(picked) : "";
    onChange(toEvent(til.id, til.name, adjusted));
  };

  return (
    <>
      <DatePickerNative
        id={fra.id}
        name={fra.name}
        label={fra.label}
        placeholder={fra.placeholder}
        value={fra.value}
        validationError={fra.validationError}
        minDate={fra.minDate}
        maxDate={fra.maxDate || parseDate(til.value)}
        disabled={fra.disabled}
        onChange={handleFraChange}
      />
      <DatePickerNative
        id={til.id}
        name={til.name}
        label={til.label}
        placeholder={til.placeholder}
        value={til.value}
        validationError={til.validationError}
        minDate={til.minDate || parseDate(fra.value)}
        maxDate={til.maxDate}
        disabled={til.disabled}
        onChange={handleTilChange}
      />
    </>
  );
}

FromToDatePickerNative.propTypes = {
  fra: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    validationError: PropTypes.string,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    disabled: PropTypes.bool,
  }).isRequired,
  til: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    validationError: PropTypes.string,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    disabled: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
